import { makeComponent } from 'ui/helpers/recipes'

import { KbdStyle } from './Kbd.css'

export const Kbd = makeComponent('span', KbdStyle)
